export default __webpack_public_path__ + "afa0d1c89b243e7ae93d968ce083791d.png";